"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectActivitySpinnerValuesCsv = collectActivitySpinnerValuesCsv;
exports.escapeSpinnerAttributeValue = escapeSpinnerAttributeValue;
exports.decodeSpinnerAttributeValue = decodeSpinnerAttributeValue;
exports.buildActivitySpinnerMarkupTag = buildActivitySpinnerMarkupTag;
const incompleteActivityChecks_1 = require("./incompleteActivityChecks");
function sortActivities(activities, sort) {
    const sorted = [...activities];
    if (sort === 'name') {
        sorted.sort((a, b) => a.name.localeCompare(b.name) || a.id.localeCompare(b.id));
        return sorted;
    }
    sorted.sort((a, b) => {
        if (a.listOrder !== b.listOrder) {
            return a.listOrder - b.listOrder;
        }
        return a.id.localeCompare(b.id);
    });
    return sorted;
}
/**
 * Comma-separated spinner values from filtered adventure activities (display names by default).
 * Activity names must not contain commas (same constraint as static {@code values} on {@code <Spinner>}).
 */
function collectActivitySpinnerValuesCsv(activities, options = {}) {
    const idsCsv = (0, incompleteActivityChecks_1.collectActivityIdsCsv)(activities, options);
    const ids = idsCsv.split(',').map((id) => id.trim()).filter(Boolean);
    if (ids.length === 0) {
        return '';
    }
    const byId = new Map(activities.map((a) => [a.id, a]));
    const matched = ids
        .map((id) => byId.get(id))
        .filter((def) => def !== undefined);
    const sort = options.sort === 'name' ? 'name' : 'list_order';
    const useNames = options.useDisplayNames !== false;
    return sortActivities(matched, sort)
        .map((def) => (useNames ? def.name.trim() : def.id))
        .filter(Boolean)
        .join(',');
}
function escapeSpinnerAttributeValue(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
/** Reverse {@link escapeSpinnerAttributeValue} when parsing {@code <Spinner>} tags. */
function decodeSpinnerAttributeValue(value) {
    return String(value)
        .replace(/&quot;/g, '"')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');
}
/**
 * Build a self-closing {@code <Spinner>} tag for embedding in descriptions or script output.
 */
function buildActivitySpinnerMarkupTag(variable, valuesCsv, defaultValue) {
    const varName = (variable ?? '').trim();
    const values = (valuesCsv ?? '').trim();
    if (!varName || !values) {
        return '';
    }
    const defaultAttr = defaultValue !== undefined && String(defaultValue).trim() !== ''
        ? ` default="${escapeSpinnerAttributeValue(String(defaultValue).trim())}"`
        : '';
    return `<Spinner variable=${escapeSpinnerAttributeValue(varName)} values="${escapeSpinnerAttributeValue(values)}"${defaultAttr} />`;
}
//# sourceMappingURL=activitySpinnerMarkup.js.map